<script setup>
import { ref } from 'vue';
import { LANDING_CONTENT } from '@/services/landing-content';

const capabilities = LANDING_CONTENT.common.capabilities;
const expandableCapabilities = LANDING_CONTENT.common.expandableCapabilities;
const showAll = ref(false);
</script>

<template>
  <section id="capabilities" class="capabilities-section">
    <div class="capabilities-container">
      <h2 class="section-title">Platform capabilities</h2>

      <div class="capabilities-grid">
        <div
          v-for="cap in capabilities"
          :key="cap.title"
          class="capability-card"
        >
          <i :class="`pi ${cap.icon} cap-icon`"></i>
          <h3 class="cap-title">{{ cap.title }}</h3>
          <p class="cap-description">{{ cap.description }}</p>
        </div>
      </div>

      <div v-if="showAll" class="expandable-grid">
        <div
          v-for="cap in expandableCapabilities"
          :key="cap.title"
          class="capability-card-small"
        >
          <h4 class="cap-title-small">{{ cap.title }}</h4>
          <p class="cap-desc-small">{{ cap.description }}</p>
        </div>
      </div>

      <button class="expand-btn" @click="showAll = !showAll">
        {{ showAll ? 'Show less' : 'See everything' }}
        <i :class="`pi ${showAll ? 'pi-chevron-up' : 'pi-chevron-down'}`"></i>
      </button>
    </div>
  </section>

  <section id="investment-strategy">
    <!-- Investment strategy content can go here -->
  </section>
</template>

<style scoped>
.capabilities-section {
  padding: 80px 24px;
  background: white;
}

.capabilities-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
  margin: 0 0 56px 0;
}

.capabilities-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}

.capability-card {
  padding: 28px;
  background: #f9fafb;
  border-radius: 12px;
  text-align: center;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.capability-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
}

.cap-icon {
  font-size: 2.5rem;
  color: #3b82f6;
  margin-bottom: 16px;
}

.cap-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.cap-description {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.expandable-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.capability-card-small {
  padding: 20px;
  background: #f9fafb;
  border-radius: 8px;
}

.cap-title-small {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 6px 0;
}

.cap-desc-small {
  font-size: 0.8125rem;
  color: #6b7280;
  margin: 0;
}

.expand-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  padding: 12px 24px;
  background: white;
  border: 2px solid #2563eb;
  color: #1e40af;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.expand-btn:hover {
  background: #dbeafe;
}

@media (max-width: 1024px) {
  .capabilities-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .capabilities-section {
    padding: 48px 16px;
  }

  .section-title {
    font-size: 1.75rem;
    margin-bottom: 40px;
  }

  .capabilities-grid,
  .expandable-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .capability-card {
    padding: 20px;
  }

  .cap-icon {
    font-size: 2rem;
  }

  .cap-title {
    font-size: 1rem;
  }

  .cap-description {
    font-size: 0.8125rem;
  }

  .expand-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
